import bankQrCodeDollar from "../assets/ac_USD.png";
import bankQrCodeRiel from "../assets/ac_KHR.png";
import acledaLogoForInvoice from "../assets/acledaLogoForInvoice.png";
import { useEffect, useState } from "react";
export default function Invoice ({room_number, monthYear})  {
    const [data, setData] = useState();
    // ==================>> Fetch API
    const getPaymentInfo = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_ENDPOINT}/payment/invoice?monthYear=${monthYear}&room_number=${room_number}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message);
            }

            const data = await response.json();
            setData(data[0]);
        } catch (err) {
            console.error(err.message);
        }
    };

    useEffect(() => {
        if (room_number && monthYear) {
            getPaymentInfo();
        }
    }, [room_number, monthYear]);

    return (
        <div className="w-full">
            <div className="flex h-[7dvh] bg-primary2 text-center text-white text-lg font-semibold">
                <div className="w-[30%] flex border-r border-black h-full items-center justify-center">{data ? data.room_number : '--'}</div>
                <div className="w-[70%] flex h-full items-center justify-center">វិក័យប័ត្របង់ប្រាក់បន្ទប់ជួល</div>
            </div>
            <div className="table-div w-full mx-0">
                <table className="border-collapse text-center w-full bg-white">
                    <thead>
                        <tr>
                            <th className="border border-black py-2 px-4 text-lg rounded-tl-md"></th>
                            <th>
                                <div className="w-full flex">
                                    <div className="border-r w-[50%] border-y border-black py-2 px-1 md:px-4 text-base md:text-lg">
                                        ខែ {data ? data.current_month : '--'}
                                    </div>
                                    <div className="border-y w-[50%] border-black py-2 px-1 md:px-4 text-base md:text-lg">
                                        ខែ {data ? data.previous_month : '--'}
                                    </div>
                                </div>
                            </th>
                            <th className="border border-black py-2 px-1 md:px-4 text-base md:text-lg">
                                ចំនួន
                            </th>
                            <th className="border-r border-y border-black py-2 px-1 md:px-4 text-base md:text-lg rounded-tr-md">
                                តម្លៃសរុប
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className="border-b border-x border-1 border-black py-2 md:px-4 md:text-lg font-semibold">តម្លៃទឹក</td>
                            <td className=" border-r border-black py-2 md:px-4 md:text-lg">
                                {data ?
                                    (Number(data.current_water_usage) % 1 === 0
                                            ? Number(data.current_water_usage).toFixed(0) 
                                            : Number(data.current_water_usage).toFixed(2) 
                                        ): ('--')} - {data ?
                                    (Number(data.previous_water_usage) % 1 === 0
                                        ? Number(data.previous_water_usage).toFixed(0) 
                                        : Number(data.previous_water_usage).toFixed(2) 
                                    ): ('--')}
                            </td>
                            <td className=" border-r border-black py-2 md:px-4 md:text-lg">{data ? data.water_usage_price / 2000 : '--'} x 2000</td>
                            <td className=" border-r  border-black py-2 md:px-4 md:text-lg">= {data ? (Number(data.water_usage_price) % 1 === 0
                                            ? Number(data.water_usage_price).toFixed(0) 
                                            : Number(data.water_usage_price).toFixed(2) 
                                        ): ('--')}R</td>
                        </tr>
                        <tr>
                            <td className="border-x border-b border-black py-2 md:px-4 md:text-lg rounded-bl-md font-semibold">តម្លៃភ្លើង</td>
                            <td className="border-r border-y border-black py-2 md:px-4 md:text-lg">គិតតាមអគ្គិសនីកម្ពុជា</td>
                            <td className="border-r border-y border-black py-2 md:px-4 md:text-lg">{data ? (Number(data.electricity_usage) === 0 ? 0 : Number(data.electricity_usage) - 1000 + '+ 1000') : '--'}</td>
                            <td className="border-r border-y border-black py-2 md:px-4 md:text-lg rounded-br-md">= {data ? Number(data.electricity_usage) : '--'}R</td>
                        </tr>
                    </tbody>
                </table>
                {/* Add table content similar to your provided layout */}
            </div>
            <div className="flex md:flex-row w-full">
                <div className="w-[52%] pl-2">
                    <div className="bg-white border px-4 py-2 rounded-md shadow-md md:w-[90%] mt-2">
                        <h3 className="font-medium">ទូរស័ព្ទអ្នកជួល: {data && data.tenant_phone_number ? 
                                                data.tenant_phone_number.replace(/(\d{3})(\d{3})(\d{3,4})/, '$1 $2 $3') 
                                                : '--'}</h3>
                    </div>
                    <div className="flex w-full mx-2 my-3 items-center font-semibold">
                        <img src={acledaLogoForInvoice} alt="acledaLogo" className="w-[40%]"/>
                        <p>Ngeabkhai Eng</p>
                    </div>
                    <div className="flex w-full mx-5 space-x-2">
                        <img src={bankQrCodeDollar} alt="bank-qr-code-dollor" className="w-24 h-24" />
                        <img src={bankQrCodeRiel} alt="bank-qr-code-dollor" className="w-24 h-24" />
                    </div>
                </div>
                <div className="w-[48%]">
                    <div className="w-full">
                        <table className="w-full">
                            <tbody>
                                <tr>
                                    <td className="border-x border-b border-black py-2 md:px-4 md:text-lg">ថ្លៃសំរាម</td>
                                    <td className="border-r border-b border-black py-2 md:px-4 md:text-lg rounded-br-md">= {data ? Number(data.garbage) : '--'}R</td>
                                </tr>
                                <tr>
                                    <td className="border-x border-b border-black py-2 md:px-4 md:text-lg">យានជំនិះ</td>
                                    <td className="border-r border-b border-black py-2 md:px-4 md:text-lg rounded-br-md">= {data ? Number(data.vehicle_charge) : '--'}R</td>
                                </tr>

                                <tr className="bg-primary2 text-white">
                                    <td className="border-x border-b border-black py-2 md:px-4 md:text-lg">ថ្លៃបន្ទប់</td>
                                    <td className="border-r border-b border-black py-2 md:px-4 md:text-lg rounded-br-md">ទឹកភ្លើងសរុប</td>
                                </tr>
                                <tr>
                                    <td className="border-x border-b border-black py-2 md:px-4 md:text-lg">= {data ? Number(data.price) : '--'}$ {data ? (data.late_penalty ? <span className="text-red-600">+ {Number(data.late_penalty)}$</span> : '') : ''}</td>
                                    <td className="border-r border-b border-black py-2 md:px-4 md:text-lg rounded-br-md">= {data ? Number(data.total_amount) : '--'}R</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};
